import React from 'react';
import Chart from 'react-apexcharts';
import { Box, Typography } from '@mui/material';
import { GreenDotIcon } from '../../../assets';
import _ from 'lodash';

const SemiDonutChart = (props) => {
    const {
        chartOptions = {},
        chartSeries,
        data_testid
    } = props;

    const validSeries =
    Array.isArray(chartSeries) && chartSeries.some((v) => v > 0)
        ? _.cloneDeep(chartSeries)
        : [];

    const labels = chartOptions?.labels || [];
    const colors = chartOptions?.colors || [];

    return (
        <>
            {/* Donut Chart */}
            <Chart
                data-testid={data_testid}
                options={_.cloneDeep(chartOptions) || {}}
                series={validSeries}
                type="donut"
                width="100%"
            />

            {/* Legends */}
            {Array.isArray(chartSeries) && chartSeries.length > 0 && chartSeries.some((v) => v > 0) && (
                <Box className="flex-column-space-between mt-10px">
                    {chartSeries.map((value, index) => (
                        <Box
                            className="flex-row-space-between"
                            key={labels[index] || index}
                        >
                            <Box className="flex-row-center gap-6">
                                <GreenDotIcon color={colors[index] || '#ccc'} />
                                <Typography className="text-sm-regular gray-500">
                                    {labels[index] || 'N/A'}
                                </Typography>
                            </Box>
                            <Typography className="text-sm-regular gray-500">
                                {value ?? 0}%
                            </Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </>
    );
};

export default SemiDonutChart;
